import { useState } from 'react'
import { Button, IconButton, Popover } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { MdOutlineArrowLeft, MdOutlineArrowRight } from 'react-icons/md'

dayjs.locale('pt-br')

export const HeaderDay = ({ selectedDate, setSelectedDate }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const today = dayjs(selectedDate)

  const formattedDate = today.format('D [de] MMMM [de] YYYY')
  const formattedDayOfWeek = today.format('dddd')

  const open = Boolean(anchorEl)

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <IconButton onClick={() => setSelectedDate(today.subtract(1, 'day'))}>
          <MdOutlineArrowLeft />
        </IconButton>

        <div
          onClick={(e) => setAnchorEl(e.currentTarget)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            minWidth: '400px',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          <h1
            style={{
              fontSize: '1.238rem',
              fontWeight: '600',
              margin: 0,
            }}
          >
            {formattedDate}
          </h1>

          <h1
            style={{
              fontSize: '1rem',
              fontWeight: '300',
              margin: 0,
              textTransform: 'capitalize',
            }}
          >
            ({formattedDayOfWeek})
          </h1>
        </div>

        <IconButton onClick={() => setSelectedDate(today.add(1, 'day'))}>
          <MdOutlineArrowRight />
        </IconButton>
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <DateCalendar
              views={['year', 'month', 'day']}
              openTo="day"
              value={today}
              onChange={(newDate) => {
                if (newDate) {
                  setSelectedDate(newDate)
                  setAnchorEl(null)
                }
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '12px',
                borderTop: '1px solid #e0e0e0',
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setSelectedDate(dayjs())
                  setAnchorEl(null)
                }}
              >
                Hoje
              </Button>
            </div>
          </div>
        </LocalizationProvider>
      </Popover>
    </>
  )
}
